<script>
import ServiceProvider from '@/components/serviceProvider';
import mixin from './mixin';
export default {
  // 服务商档案 系统组件
  name: 'CServiceProvider',
  mixins: [mixin],
  props: {
    value: {
      type: Object,
      default: null,
    },
    customerId: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '请选择服务商',
    },
  },
  components: {
    ServiceProvider,
  },
  data () {
    return {
      contactUserId: this.value?.id,
      contactUserName: this.value?.name,
    };
  },
  watch: {
    value () {
      this.contactUserId = this.value?.id;
      this.contactUserName = this.value?.name;
    },
  },
  methods: {
    handleUserChanged (data) {
      this.contactUserId = data?.id;
      this.contactUserName = data?.name;
      this.$emit('input', data);
    },
  },
  render () {
    return (
      <ServiceProvider
        size={this.inputSize}
        placeholder={this.placeholder}
        value={this.contactUserId}
        name={this.contactUserName}
        readonly={this.inputDisabled}
        onChange={this.handleUserChanged}
        customerId={this.customerId}
      ></ServiceProvider>
    );
  },
};
</script>
